import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { FooterText } from "../theme/Typography"
import { onPhone, onTablet, OnPhone, NotPhone } from "../theme/MediaQueries"

const StyledFooter = styled.footer`
  height: 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${onPhone} {
    height: auto;
    flex-direction: column-reverse;
  }

  ${onTablet} {
    padding: 0 16px;
  }
`

const StyledAnchor = styled.a`
  all: unset;
  &:hover {
    cursor: pointer;
  }
`

const FooterItem = styled.div`
  ${FooterText};

  & > ${StyledAnchor} {
    margin: 0 4px 0 4px;
    ${onPhone} {
      margin: 0 16px 0 16px;
    }
  }

  ${onPhone} {
    padding: 8px;
    text-align: center;
  }
`

const DATENSCHUTZ_URL = "https://www.finanzcheck.de/datenschutz-sc/"
const IMPRESSUM_URL = "https://www.finanzcheck.de/impressum/"

const Footer = () => (
  <StyledFooter>
    <NotPhone>
      <FooterItem>
        © {new Date().getFullYear()} FINANZCHECK.de • Admiralitätstraße 60 • 20459
        Hamburg
      </FooterItem>
    </NotPhone>
    <OnPhone>
      <FooterItem>
        © {new Date().getFullYear()} FINANZCHECK.de
        <br />
          Admiralitätstraße 60 - 20459 Hamburg
      </FooterItem>
    </OnPhone>
    <FooterItem>
      <StyledAnchor href={DATENSCHUTZ_URL}>Datenschutz</StyledAnchor>
      <StyledAnchor href={IMPRESSUM_URL}>Impressum</StyledAnchor>
    </FooterItem>
  </StyledFooter>
)

Footer.propTypes = {}

Footer.defaultProps = {}

export default Footer
